import {MI} from "../init";
import {madnes_get_json} from "../../framework/src/engine/madnes/madnes";

/**
 * @constructor
 */
export default function BoomSpinOption() {

    this._starsCount = 3;

    /** @type {MadnesObject} */
    this._parent;

    /** @type {MadnesObject} */
    this._bgShine;

    /** @type {string} */
    this.type;

    /** @type {MadnesObject} */
    this._label;

    /** @type {MadnesObject} */
    this._smoke1;

    /** @type {MadnesObject} */
    this._smoke2;

    /** @type {MadnesObject} */
    this._smoke3;

    /** @type {MadnesObject} */
    this._smoke4;

    /** @type {MadnesObject} */
    this._btn;

    this._buttonDisabled = false;

    /** @type {Function} */
    this._onChoose = function() {};

    this._s1Pos = { "x": -180, "y": -180 };
    this._s2Pos = { "x": 220, "y": 0 };
    this._s3Pos = { "x": 140, "y": 250 };
    this._s4Pos = { "x": -210, "y": 170 };

    /** @type {Array<MadnesTween>} */
    this._tweens = [];
}

/** @param {Function} func */
BoomSpinOption.prototype.setOnChoose = function(func) {
    this._onChoose = func;
};

/** @param {number} starsCount */
BoomSpinOption.prototype.setStarsCount = function(starsCount) {
    this._starsCount = starsCount;
    this._setLabel();
};

/** @param {boolean} disabled */
BoomSpinOption.prototype.setButtonDisabled = function(disabled) {
    this._buttonDisabled = disabled;
};

BoomSpinOption.prototype.setButtonTexture = function(dark) {
    this._btn.setFrameName(dark ? "btn_choose_pressed" : "btn_choose_basic");
};

BoomSpinOption.prototype.getBsCount = function() {

    if(this._starsCount > 3) {
        return this.type === "double" ? 10 : 20;
    } else {
        return this.type === "double" ? 5 : 10;
    }
};

BoomSpinOption.prototype.getPickIndex = function() {
    if(this._starsCount > 3) {
        return this.type === "double" ? 3 : 1;
    } else {
        return this.type === "double" ? 2 : 0;
    }
};

BoomSpinOption.prototype._setLabel = function() {
    var bsCount = this.getBsCount();
    this._label.setFrameName("num_" + bsCount);
};

/**
 * @param {MadnesObject} smoke
 * @param {Object} pos
 */
BoomSpinOption.prototype._setSmokePos = function(smoke, pos) {
    smoke.setPos(pos['x'], pos['y']);
};

BoomSpinOption.prototype._getParentPos = function() {
    var x = this.type === "double" ? 300 : -300;

    return {
        'x': MI.getWi() / 2 + x,
        'y': MI.getHe() / 2 - 14
    };
};

BoomSpinOption.prototype.reinit = function() {
    this._setSmokePos(this._smoke1, this._s1Pos);
    this._smoke1.setAngle(0);

    this._setSmokePos(this._smoke2, this._s2Pos);
    this._smoke2.setAngle(0);

    this._setSmokePos(this._smoke3, this._s3Pos);
    this._smoke3.setAngle(0);

    this._setSmokePos(this._smoke4, this._s4Pos);
    this._smoke4.setAngle(0);

    var parentPos = this._getParentPos();

    this._parent.setPos(parentPos['x'], parentPos['y']);
    this._parent.setVisible(true);

    this._parent.setAngle(0);
    this._parent.setAlpha(0);
    this._parent.setScale(0, 0);

    this._bgShine.setAlpha(1);
    this._bgShine.setScale(1, 1);
    this._bgShine.setVisible(false);

    this._btn.setFrameName("btn_choose_basic");
};

BoomSpinOption.prototype.create = function(type) {

    this.type = type;

    var parentPos = this._getParentPos();

    var parent = MI.addImg(parentPos['x'], parentPos['y'], "");
    parent.setAnchor(0.5, 0.5);

    this._smoke1 = MI.addImg(this._s1Pos['x'], this._s1Pos['y'], "bonus_atlas");
    this._smoke1.setFrameName("smoke_bg_01");
    this._smoke1.setAnchor(0.5, 0.5);
    parent.addChild(this._smoke1);

    this._smoke2 = MI.addImg(this._s2Pos['x'], this._s2Pos['y'], "bonus_atlas");
    this._smoke2.setFrameName("smoke_bg_02");
    this._smoke2.setAnchor(0.5, 0.5);
    parent.addChild(this._smoke2);

    this._smoke3 = MI.addImg(this._s3Pos['x'], this._s3Pos['y'], "bonus_atlas");
    this._smoke3.setFrameName("smoke_bg_03");
    this._smoke3.setAnchor(0.5, 0.5);
    parent.addChild(this._smoke3);

    this._smoke4 = MI.addImg(this._s4Pos['x'], this._s4Pos['y'], "bonus_atlas").setFrameName("smoke_bg_04");
    this._smoke4.setAnchor(0.5, 0.5);
    parent.addChild(this._smoke4);

    var bg = MI.addImg(0, 0, "bonus_atlas").setFrameName("table_bg");
    bg.setAnchor(0.5, 0.5);
    parent.addChild(bg);

    this._bgShine = MI.addImg(0, 0, "bonus_atlas").setFrameName("table_bg");
    this._bgShine.setAnchor(0.5, 0.5);
    this._bgShine.setBlend("ADD");
    this._bgShine.setVisible(false);
    parent.addChild(this._bgShine);

    var wild = MI.addImg(-130, 35, "bonus_atlas").setFrameName("wild_preview");
    wild.setAnchor(0.5, 0.5);
    parent.addChild(wild);

    if(type === "double") {
        var wild2 = MI.addImg(130, 35, "bonus_atlas").setFrameName("wild_preview");
        wild2.setAnchor(0.5, 0.5);
        parent.addChild(wild2);
    }

    this._label = MI.addImg(0, -214, "bonus_atlas");
    this._setLabel();
    this._label.setAnchor(0.5, 0.5);
    parent.addChild(this._label);

    var sign = MI.addImg(0, -100, "bonus_atlas").setFrameName("sign");
    sign.setAnchor(0.5, 0.5);
    parent.addChild(sign);

    var shine = MI.addImg(0, 220, "bonus_atlas").setFrameName("btn_shine");
    shine.setAnchor(0.5, 0.5);
    parent.addChild(shine);

    this._btn = MI.addImg(0, 220, "bonus_atlas").setFrameName("btn_choose_basic");
    this._btn.setAnchor(0.5, 0.5);
    parent.addChild(this._btn);

    var btn = madnes_get_json("infotext")["buttons"]["bonus_select"];

    var styleBtn = {};

    styleBtn["font"] = btn["fontSize"] + "px " + btn["font"];
    styleBtn["fill"] = "#FEC900"; //btn["color"];
    styleBtn["fontWeight"] = "bold";

    var text = MI.addText(0, 222, "ZVOLIT", styleBtn);
    text.setAnchor(0.5, 0.5);
    parent.addChild(text);

    parent.onInputDown(function() {

        if(this._buttonDisabled) {
            return;
        }

        this._btn.setFrameName("btn_choose_pressed");
    }.bind(this));

    parent.onInputUp(this.choose.bind(this));

    parent.setScale(0, 0);
    parent.setAlpha(0);

    this._parent = parent;

    return parent;
};

BoomSpinOption.prototype.choose = function() {

    if(this._buttonDisabled) {
        return;
    }

    var _self = this;

    this._buttonDisabled = true;

    this._btn.setFrameName("btn_choose_disabled");

    _self._bgShine.setVisible(true);
    MI.addTween().to(this._bgShine, { 'x': 1.26, 'y': 1.26 }, {
        'scale': true,
        'duration': 500,
    });

    MI.addTween().to(this._bgShine, { 'alpha': 0 }, {
        'duration': 500,
        'callback': function() {
            _self._bgShine.setVisible(false);
        }
    });

    this._onChoose(this);
};

/** @returns {MadnesObject} */
BoomSpinOption.prototype.getObject = function() {
    return this._parent;
};

/**
 * @param {MadnesObject} smoke
 * @param {number} x
 * @param {number} y
 * @param {number} delay
 * @param {number} duration
 * @returns {MadnesTween}
 */
BoomSpinOption.prototype._animSmokeMove = function(smoke, x, y, delay, duration) {

    var initX = smoke.getPosX();
    var initY = smoke.getPosY();
    var angle = smoke.getAngle() + getRandomInt(-6, 6);

    return MI.addTween().to(smoke, { 'x': initX + x, 'y': initY + y, 'angle': angle }, {
        'delay': delay,
        'duration': duration,
        'count': -1,
        'yoyo': true,
        'easing': MadnesTween.getEasing("sinusoidal_in_out")
    });
};

BoomSpinOption.prototype._animSmokeScale = function(smoke, delay, duration) {
    return MI.addTween().to(smoke, { 'x': 0.9, 'y': 0.9 }, {
        'scale': true,
        'delay': delay,
        'duration': duration,
        'count': -1,
        'yoyo': true,
        'easing': MadnesTween.getEasing("sinusoidal_in_out")
    });
};

BoomSpinOption.prototype.animSmoke = function() {

    var pos = {
        "single": [
            { 'x': -6, 'y': -8 },
            { 'x': -10, 'y': 6 },
            { 'x': 7, 'y': -6 },
            { 'x': 8, 'y': 7 }
        ],
        "double": [
            { 'x': 8, 'y': 6 },
            { 'x': 7, 'y': -9 },
            { 'x': -6, 'y': 7 },
            { 'x': -8, 'y': -9 }
        ]
    };

    var t = this.type;
    var tween;

    var duration = getRandomInt(1400, 1600);
    var delay = getRandomInt(0, 500);

    tween = this._animSmokeMove(this._smoke1, pos[t][0]['x'], pos[t][0]['y'], delay, duration);
    this._tweens.push(tween);
    tween = this._animSmokeScale(this._smoke1, delay, duration);
    this._tweens.push(tween);

    delay = getRandomInt(0, 500);
    tween = this._animSmokeMove(this._smoke2, pos[t][1]['x'], pos[t][1]['y'], delay, duration);
    this._tweens.push(tween);
    tween = this._animSmokeScale(this._smoke2, delay, duration);
    this._tweens.push(tween);

    delay = getRandomInt(0, 500);
    tween = this._animSmokeMove(this._smoke3, pos[t][2]['x'], pos[t][2]['y'], delay, duration);
    this._tweens.push(tween);
    tween = this._animSmokeScale(this._smoke3, delay, duration);
    this._tweens.push(tween);

    delay = getRandomInt(0, 500);
    tween = this._animSmokeMove(this._smoke4, pos[t][3]['x'], pos[t][3]['y'], delay, duration);
    this._tweens.push(tween);
    tween = this._animSmokeScale(this._smoke4, delay, duration);
    this._tweens.push(tween);
};

BoomSpinOption.prototype.stopTweens = function() {

    for(var i = 0; i < this._tweens.length; i++) {
        this._tweens[i].stop();
    }

    this._tweens.length = 0;
};